// extracted by mini-css-extract-plugin
module.exports = {"Banner":"Banner_Banner__Fm3cB"};